// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const diglett: PokeData = {
  "id": 50,
  "name": "diglett",
  "height": 2,
  "weight": 8,
  "base_experience": 53,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "growl",
    "earthquake",
    "fissure",
    "dig",
    "agility",
    "fury-swipes",
    "slash",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "astonish",
    "sucker-punch",
    "earth-power",
    "mud-bomb",
    "bulldoze"
  ],
  "moves": [
    "scratch",
    "growl",
    "earthquake",
    "fissure",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "earth-power",
    "mud-bomb",
    "bonemerang",
    "bone-throw",
    "mud-shot",
    "rototiller"
  ],
  "evolution_chain": {
    "id": 21,
    "item": null,
    "species": [
      {
        "name": "diglett",
        "order": 55,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dugtrio",
        "order": 56,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 50,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 22.5,
    "speed": 95,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
